import Navigation from "./Navigation";

export default {
    install(Vue) {
        // Make navigation and its properties reactive.
        let app = new Vue({
            data: {
                navigation: new Navigation()
            }
        });
        Vue.prototype.$navigation = app.navigation;
    }
}
  